import { createAction, props } from "@ngrx/store";
import {
  RoomBrandBgDeferredErrorVO,
  RoomBrandBgDeleteEventVO,
  RoomBrandBgSetEventVO
} from "@youm-front/room/domain";

export const roomBrandBgSetEvent = createAction(
  "[Room] Room Brand Bg Set Event",
  props<{ roomBrandBgSetEventVO: RoomBrandBgSetEventVO }>()
);

export const roomBrandBgDeleteEvent = createAction(
  "[Room] Room Brand Bg Delete Event",
  props<{ roomBrandBgDeleteEventVO: RoomBrandBgDeleteEventVO }>()
);

export const roomBrandBgDeferredErrorEvent = createAction(
  "[Room] Room Brand Bg Deferred Error Event",
  props<{
    roomBrandBgDeferredErrorVO: RoomBrandBgDeferredErrorVO;
  }>()
);
